import { makeVar } from '@apollo/client';

interface ISearchProps {
  phrase: string;
}

export const globalSearchVar = makeVar<ISearchProps>({
  phrase: '',
});
